import React from 'react';
import Section from "./Section.js";
import SubSection from "./SubSection.js";
import Banner from "./Banner.js";
import QuestionBanner from "./QuestionBanner.js";
import Question from './Question';
import ListPicker from "./ListPicker";
import Actions from "../modules/actions";
import { connect } from "react-redux";
import WebCamModal from "./WebCamModal";
import { Typography, Grid } from '@material-ui/core';
import MyButton from "./MyButton";
import Link from "./Link";
import B from "./B";
import SelectImage from "../modules/SelectImage";


const mapStateToProps = (state, ownProps) => {
  let facades = [];
  let facade = {};
  const building = state.buildings.find(b => b.buildingId === state.currentBuildingId);
  if(building) {
    facades = building.facades;
    facade = facades.find(f => f.facadeId === state.currentFacadeId);
  } else {
    // I should make this only throw if there are buildings and there is a current building selected...
    //throw new Error("could not find building");
  }
  return ({
    building,
    currentBuildingId: state.currentBuildingId,
    facade,
    currentFacadeId: state.currentFacadeId,
  });
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  setDesignFeature: (bId, fId, index) => dispatch(Actions.setDesignFeature(bId, fId, index)),
  setImage: (buildingId, facadeId, imageSrc) => dispatch(Actions.setImage(buildingId, facadeId, imageSrc)),
});

/*
Here is what Michael said about facade-level and building-level questions
    regional -> building
    local -> facade
    facade -> facade
    prop -> facade
    visual -> facade
    local -> building
    building -> b f f f f 
*/
const Assess = props => {
  const Lang = props.lang.Assess;
  return (
    <Section id="Assess" header={Lang.header} startExpanded>
      <SubSection>
        <Typography component="div">
          {Lang.currently_assessing} <B text={props.currentFacadeId} alt={Lang.current}/> {Lang.facade_for}  <B text={props.currentBuildingId} alt={Lang.current_building}/>.
          {Lang.to_include_image_of} <B text={props.currentFacadeId} alt={Lang.current_facade}/> {Lang.take_picture_or_select_image_now}
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={6} cols={1}>
            <WebCamModal Lang={Lang} facade={props.facade}/>
          </Grid>
          <Grid item xs={6} cols={1}>
            <MyButton variant="contained" disabled={!(props.facade && props.facade.facadeId)}
                onClick={() => SelectImage(src => props.setImage(props.currentBuildingId, props.currentFacadeId, src))}>
                  {Lang.select_an_image}
              </MyButton>
          </Grid>
        </Grid>
        
        {props.facade && props.facade.imageSrc &&
          <img src={props.facade.imageSrc} style={{width: "100%"}} alt=""/>}
        {false && props.facade && props.facade.imageSrc &&
          <MyButton variant="contained" onClick={() => console.log("rotate image")}>{"Rotate Image"}</MyButton>}
      </SubSection>


      <Banner title={Lang.daytime_factors} subTitle={Lang.observe_factors_in_daylight}/>
      <Typography>{Lang.daytime_prompt}</Typography>

      <QuestionBanner header={Lang.regional_landscape}/>
      <SubSection>
        <Link url="https://www.google.ca/maps" text={Lang.google_maps}/>
      </SubSection>
      <Typography>{Lang.are_features_regional}</Typography>
      <Question id="q01" text={Lang.q01} isBuildingLevel/>
      <Question id="q02" text={Lang.q02} isBuildingLevel/>
      <Question id="q03" text={Lang.q03} isBuildingLevel/>

      <QuestionBanner header={Lang.local_landscape}/>
      <Typography>{Lang.are_features_local}</Typography>
      <Question id="q04" text={Lang.q04}/>
      <Question id="q05" text={Lang.q05}/>
      <Question id="q06" text={Lang.q06}/>
      <Question id="q07" text={Lang.q07}/>

      <QuestionBanner header={Lang.facade_type}/>
      <SubSection>
        <ListPicker header={Lang.design_feature} options={Lang.design_feature_options}
          disabled={!props.currentFacadeId}
          val={props.facade && Lang.design_feature_options[props.facade.designFeatureIndex] || ""}
          setVal={value => {
            let index = Lang.design_feature_options.indexOf(value);
            if(index === -1) {
              // this happens when they select "None"
              index = undefined;
            }
            props.setDesignFeature(props.currentBuildingId, props.currentFacadeId, index);
          }}/>
      </SubSection>
      {props.facade && props.facade.designFeatureIndex !== undefined &&
        <Question id="q09" text={Lang.q09[props.facade.designFeatureIndex]}/>}
      {props.facade && props.facade.designFeatureIndex !== undefined &&
        <Question id="q10" text={Lang.q10[props.facade.designFeatureIndex]}/>}

      <QuestionBanner header={Lang.properties_of_glass}/>
      <Question id="q11" text={Lang.q11}/>
      <Question id="q12" text={Lang.q12}/>
      
      <QuestionBanner header={Lang.visual_markers}/>
      <SubSection>
        <Typography>{Lang.def_of_visual_marker}</Typography>
        <Link url="https://birdsafe.ca/workplaces-safe-for-birds/" text={Lang.see_examples_of_visual_markers}/>
        <Typography>{Lang.note_that_inverted}</Typography>
      </SubSection>
      <Question id="q13" text={Lang.q13}/>
      <Question id="q14" text={Lang.q14}/>
      <Question id="q15" text={Lang.q15}/>
      <Question id="q16" text={Lang.q16}/>


      <Banner title={Lang.nighttime_factors} subTitle={Lang.observe_factors_in_darkness}/>
      <Typography>{Lang.nighttime_prompt}</Typography>

      <QuestionBanner header={Lang.local_landscape_with_dist}/>
      <Question id="q17" text={Lang.q17} isBuildingLevel/>
      <Question id="q18" text={Lang.q18} isBuildingLevel/>

      <QuestionBanner header={Lang.building_lighting}/>
      <Question id="q23" text={Lang.q23} isBuildingLevel/>
      <Question id="q19" text={Lang.q19}/>
      <Question id="q20" text={Lang.q20}/>
      <Question id="q21" text={Lang.q21}/>
      <Question id="q22" text={Lang.q22}/>

      {
        // I don't need a save MyButton (so no step 4)
        // For now, I'll leave this blank, but I will probably need to
        //   turn steps 5 and 6 into 4 and 5, and include them
      }
    </Section>
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Assess);



// WEBPACK FOOTER //
// ./src/pages/Assess.js